import { SmartBezierEdge } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/SmartEdge/SmartBezierEdge/SmartBezierEdge.tsx';

export const DebtEdge = (props) => <SmartBezierEdge {...props} labelStyle={{ display: 'none' }} />;
